"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var sis_paging_component_1 = require("./sis-paging.component");
require("./sis-list-paging.component.css");
var ListPaging = /** @class */ (function () {
    function ListPaging() {
        this._page = 0;
        this._pageSize = 0;
    }
    Object.defineProperty(ListPaging.prototype, "pageSize", {
        set: function (pageSize) {
            this._pageSize = pageSize;
            this._initPageItems();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListPaging.prototype, "items", {
        get: function () {
            return this._items;
        },
        set: function (items) {
            this._page = 0;
            this._items = items;
            this._initPageItems();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListPaging.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (page) {
            this._page = page;
            this._initPageItems();
        },
        enumerable: true,
        configurable: true
    });
    ListPaging.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.pagingElements.forEach(function (paging, index) {
            paging.pageSize = _this._pageSize;
            paging.totalPageCount = _this._getTotalPageCount();
            paging.itemsCount = _this._items.length;
        });
    };
    ListPaging.prototype.ngOnChanges = function (changes) {
        changes['items'] && (this.items = changes['items'].currentValue);
    };
    Object.defineProperty(ListPaging.prototype, "pageItems", {
        get: function () {
            return this._pageItems;
        },
        enumerable: true,
        configurable: true
    });
    ListPaging.prototype._getTotalPageCount = function () {
        return Math.floor(this._items.length / this._pageSize) + (this._items.length % this._pageSize == 0 ? 0 : 1);
    };
    ListPaging.prototype._initPageItems = function () {
        var _this = this;
        if (this._items !== undefined && this._pageSize !== undefined && this._page !== undefined) {
            var start = this._page * this._pageSize;
            var end = start + this._pageSize - 1;
            if (end > this._items.length - 1) {
                end = this._items.length - 1;
            }
            this._pageItems = new SubArray(this._items, start, end);
            this.pagingElements && this.pagingElements.forEach(function (paging) {
                paging.pageSize = _this._pageSize;
                paging.totalPageCount = _this._getTotalPageCount();
                paging.itemsCount = _this._items.length;
            });
        }
    };
    __decorate([
        core_1.ContentChildren(sis_paging_component_1.Paging),
        __metadata("design:type", core_1.QueryList)
    ], ListPaging.prototype, "pagingElements", void 0);
    __decorate([
        core_1.Input('pageSize'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], ListPaging.prototype, "pageSize", null);
    __decorate([
        core_1.Input('items'),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], ListPaging.prototype, "items", null);
    __decorate([
        core_1.Input('page'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], ListPaging.prototype, "page", null);
    ListPaging = __decorate([
        core_1.Component({
            
            selector: 'sis-list-paging',
            template: require('./sis-list-paging.component.html')
        })
    ], ListPaging);
    return ListPaging;
}());
exports.ListPaging = ListPaging;
var SubArrayIterator = /** @class */ (function () {
    function SubArrayIterator(array, start, end) {
        this.array = array;
        this.start = start;
        this.end = end;
        this.index = start;
    }
    SubArrayIterator.prototype.next = function () {
        if (this.index <= this.end) {
            return {
                done: false,
                value: this.array[this.index++]
            };
        }
        else {
            return {
                done: true,
                value: undefined
            };
        }
    };
    return SubArrayIterator;
}());
exports.SubArrayIterator = SubArrayIterator;
var SubArray = /** @class */ (function () {
    function SubArray(array, start, end) {
        this.array = array;
        this.start = start;
        this.end = end;
    }
    SubArray.prototype[Symbol.iterator] = function () {
        return new SubArrayIterator(this.array, this.start, this.end);
    };
    return SubArray;
}());
exports.SubArray = SubArray;
//# sourceMappingURL=sis-list-paging.component.js.map